const dashboardMenu = [
  {
    title: "Quiz",
    title2: "Created",
    count: 12,
    color: "#FF5D01",
    id: 0,
  },
  {
    title: "Question",
    title2: "Created",
    count: 110,
    color: "#60B84B",
    id: 1,
  },
  {
    title: "Total",
    title2: "Impressions",
    count: 989,
    color: "#5076FF",
    id: 2,
  },
];

export { dashboardMenu, };
